import { useQuery } from "react-query";
import { adminGetAllConversations } from "services/conversation.service";

export default function useAdminConversations(params?: { page?: number; limit?: number }) {
  return useQuery(
    ["admin-conversations", params],
    () => adminGetAllConversations(params),
    { keepPreviousData: true }
  );
}
